import { getUniqueOutboundPhoneNumbers } from './getUniqueOutboundPhoneNumbers';

export const outboundPhoneNumberService = {
  getUniqueOutboundPhoneNumbers,
};
